import { Header } from "@/app/layout/Header";
import { Main } from "@/app/layout/Main";

export function ChecklistNotFoundState() {
  return (
    <>
      <Header />
      <Main>
        <div className="flex items-center justify-center p-8">
          <p className="text-muted-foreground">ບໍ່ພົບ Checklist ID</p>
        </div>
      </Main>
    </>
  );
}
